import "./App.css";
import Search from "./Search";

function App() {
  return (
    <div className="App">
      <Search />
      <footer>
        This page was created by{" "}
        <a href="https://www.shecodes.io/graduates/156305-sonja-grund">Sonja</a>{" "}
        and is open-sourced on{" "}
        <a href="https://github.com/itsSonchan">Github.</a>
      </footer>
    </div>
  );
}

export default App;
